module.exports = __webpack_public_path__ + "static/exterior-4-d975b67f5f6aceb1237ae6b51180d9cf.jpg";